import getBusinessScopeDiscount from '../../axios/order/discount/businessScope/get'
import { setCartDiscount, setCartInitialDiscount, setCategoryDiscountConfig } from '../../action/cartDiscount'
import { setCartDiscountTypeWithStorageThunk } from './withStorage'
import { retrieveErrorFromApi } from '../../../helper'
import { setAppErrors } from '../../action/system'
import getCategoryDiscount from '../../axios/categoryDiscounts/discountByCategory/get'
import { getCategoryDiscountIsActive } from '../../selector/cart/helper'

export const KASSA_MODULE = 'KASSA'
export const ONLINE_SHOP_MODULE = 'ONLINE_SHOP'

export const getBusinessScopeDiscountThunk =  (businessScope) => async dispatch => {
	try {
		const res = await getBusinessScopeDiscount(businessScope)
		const businessScopeDiscount = res.data
		dispatch(setCartInitialDiscount(businessScopeDiscount))
		dispatch(setCartDiscount(businessScopeDiscount.discount))
		dispatch(setCartDiscountTypeWithStorageThunk(businessScopeDiscount.discountType))
		return businessScopeDiscount
	} catch (error) {
		dispatch(setCartInitialDiscount({ discount: 0, discountType: 'PERCENTS' }))
		dispatch(setCartDiscount(0))
		dispatch(setCartDiscountTypeWithStorageThunk('PERCENTS'))
	}
}

export const getCategoryDiscountThunk = (companyIndex, categoryId, module = KASSA_MODULE) => async (dispatch, getState) => {
	const cacheKey = `${module}:${categoryId}`
	const cached = getState().cartDiscount?.categoryDiscountConfigs?.[cacheKey]
	if (cached !== undefined) return cached
	try {
		const res = await getCategoryDiscount({ companyIndex, categoryId, module })
		dispatch(setCategoryDiscountConfig({ ...getState().cartDiscount?.categoryDiscountConfigs, [cacheKey]: res.data }))
		return res.data
	} catch (error) {
		dispatch(setAppErrors(retrieveErrorFromApi(error)))
	}
}

export const getItemCategoryDiscountInfoThunk = (item, { companyIndex, orderType, companyCountryCode, module }) => async dispatch => {
	if (!item?.categoryId) return null
	const config = await dispatch(getCategoryDiscountThunk(companyIndex, item.categoryId, module))
	return getCategoryDiscountIsActive(config, item, companyCountryCode, orderType)
}
